<template>
  <div class="page-content animate__animated animate__fadeIn">
    <div class="border-bottom" style="margin-top:0;">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="线路名" prop="circuitId">
            <el-select clearable v-model="queryParams.circuitId" placeholder="请选择线路名进行查询" @change="circuitChange">
              <el-option v-for="item in circuitList" :key="item.circuitId" :label="item.circuitName"
                :value="item.circuitId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="行别">
            <el-select v-model="queryParams.lineType" placeholder="请选择行别" clearable @change="lineTypeChange">
              <el-option v-for="item in lineTypeList" :key="item.dictCode" :label="item.dictLabel"
                :value="item.dictValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="站区" prop="stationId" v-if="queryParams.lineType">
            <el-select v-model="queryParams.stationId" placeholder="请选择站区进行查询" clearable>
              <el-option v-for="item in stationList" :key="item.stationId" :label="item.stationName"
                :value="item.stationId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支柱编号">
            <el-input v-model="queryParams.pillarNum" placeholder="请输入支柱编号进行查询" class="form-item-width"
              clearable></el-input>
          </el-form-item>

          <div class="btn-boxs">
            <div>
              <el-button icon="el-icon-plus" type="primary" @click="handlepillarAdd">新 增</el-button>
              <el-button :disabled="!multipleSelection.length" icon="el-icon-delete" type="danger"
                @click="batchDelete">批量删除</el-button>
            </div>
            <div>
              <el-button icon="el-icon-search" type="primary" @click="onSearch">查 询</el-button>
              <el-button icon="el-icon-refresh" @click="onReset">重 置</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="margin-top" style="margin-bottom:0;margin-top:15px">
      <!-- 表格组件 -->
      <el-table :data="tableData" v-loading="tableLoading" border row-key="deptId" default-expand-all
        :tree-props="{ children: 'children' }" highlight-current-row max-height="447"
        :header-cell-style="{ background: '#fafafa', color: '#606266', fontSize: '14px' }"
        @selection-change="handleSelectionChange">
        <!-- 多选 -->
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- 序号列 -->
        <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
        <!-- 动态生成其他列 -->
        <el-table-column align="center" v-for="tab in tableTitle" :key="tab.code" :label="tab.name"
          show-overflow-tooltip :width="tab.width">
          <template slot-scope="scope">
            <!-- 针对 status 列的特殊处理 -->
            <span v-if="tab.code === 'status'"
              :style="scope.row.status === '0' ? { color: 'green' } : { color: 'red' }">{{ scope.row.status === '0' ?
          '正常' : '停用' }}</span>

            <span v-else>{{ scope.row[tab.code] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="updateData(scope.row)" class="update-btn">修改</el-button>
            <el-button style="color:red" type="text" @click="deleteData(scope.row)" class="update-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination background :total="pageParams.total" :page="pageParams.pageNum" :limit="pageParams.pageSize"
          @pagination="onChangePages" />
      </div>
    </div>
    <!-- 添加 修改角色 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisble" width="30%" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="区站" prop="stationId">
          <el-select v-model="form.stationId" placeholder="请选择区站">
            <el-option v-for="item in stationList" :key="item.stationId" :label="item.stationName"
              :value="item.stationId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支柱编号" prop="pillarNum">
          <el-input v-model="form.pillarNum" autocomplete="off" placeholder="请输入支柱编号"></el-input>
        </el-form-item>
        <el-form-item label="公里标" prop="startKilometerSign">
          <el-input v-model="form.startKilometerSign" autocomplete="off" placeholder="请输入公里标"></el-input>
        </el-form-item>
        <el-form-item label="结构标识" prop="type">
          <el-input v-model="form.type" autocomplete="off" placeholder="请输入公里标"></el-input>
        </el-form-item>
        <!-- <el-form-item label="结束公里标" prop="endKilometerSign">
          <el-input
            type="number"
            v-model="form.endKilometerSign"
            @input="validateNumber('endKilometerSign')"
            autocomplete="off"
          ></el-input>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :icon="dialogTitle === '新增' ? 'el-icon-plus' : 'el-icon-edit'" type="primary"
          @click="submitForm('form')">{{ dialogTitle === '新增' ? '立即添加' : '立即修改' }}</el-button>
        <el-button icon="el-icon-refresh" @click="resetForm('form')">重 置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import {
  getPillarList,
  pillarAdd,
  pillarById,
  updetePillar,
  deletePillar
} from "@/api/data-service/pillar.js";
import { getStationAll } from "@/api/data-service/station.js";
import { getCircuitAll } from "@/api/data-service/line.js";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      tableLoading: false,
      form: {
        pillarNum: "",
        stationId: "",
        startKilometerSign: "",
        type: ""
      },
      rules: {
        pillarNum: [
          { required: true, message: "请填写支柱编号", trigger: "blur" }
        ],
        stationId: [
          { required: true, message: "请选择区站", trigger: "change" }
        ],
        startKilometerSign: [
          { required: true, message: "请填写公里标", trigger: "blur" }
        ]
      },
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      dialogFormVisble: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "区站", code: "stationName", width: "" },
        { name: "支柱编号", code: "pillarNum", width: "" },
        { name: "公里标", code: "startKilometerSign", width: "" },
        { name: "结构标识", code: "type", width: "" }
      ],
      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        updateBy: "",
        updateTime: "",
        remark: "",
        circuitId:"",
        stationId:"",
        lineType:"",
        pillarNum: "", //	支柱编号
        kilometerSign: "" // 	公里标
      },
      stationList: [],
      circuitList:[],
      lineType:[],
      multipleSelection: []
    };
  },
  mounted() {
    this.onGetDataList();
    this.init();

  },

  methods: {
    async init() {
      const res = await getCircuitAll({});
        this.circuitList = res?.data || [];
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchDelete() {
      this.$confirm(`提示，确定要删除选中的这些数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          // 使用 map() 来获取 pillarId 组成的数组
          const ids = (this.multipleSelection || []).map(item => item.pillarId);
          deletePillar({ ids }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    validateNumber(field) {
      let value = this.form[field];
      // 如果值为空或非数字，清空输入
      if (value === "" || isNaN(value)) {
        this.form[field] = "";
        return;
      }
      // 确保输入值大于0
      if (parseFloat(value) <= 0) {
        this.$nextTick(() => {
          this.form[field] = "";
        });
        this.$message.error("请输入大于0的数字");
      }
    },
    circuitChange(newValue) {
      this.queryParams.lineType = "";
      this.queryParams.stationId = "";
      this.queryParams.circuitId = newValue;
      this.circuitList.forEach(item => {
        if (item.circuitId === newValue) {
          if (item.type === "0") {
            // 说明是单线
            this.lineTypeList = [
              {
                dictLabel: "单线",
                dictValue: "0"
              }
            ];
          } else {
            this.lineTypeList = [
              {
                dictLabel: "上行",
                dictValue: "1"
              },
              {
                dictLabel: "下行",
                dictValue: "2"
              }
            ];
          }
        }
      });
    },
    lineTypeChange(val) {
      this.queryParams.stationId = "";
      this.queryStaionList(this.queryParams.circuitId, val);
    },
    queryStaionList(circuitId, lineType) {
      getStationAll({
        stationName: "", //区站名称
        circuitId,
        lineType,
        ...this.pageParams
      }).then(res => {
        this.stationList = res?.data || [];
      });
    },
    addData() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    // 增 / 改
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const formData = { ...this.form };
          delete formData.pillarId; // 清除 pillarId
          if (this.dialogTitle === "新增") {
            pillarAdd({
              ...formData,
              startKilometerSign: "k" + String(this.form.startKilometerSign),
              endKilometerSign: "k" + String(this.form.endKilometerSign)
            }).then(res => {
              if (res.data) {
                this.$message.success(res.msg || "新增成功！");
                this.dialogFormVisble = false;
                this.onGetDataList();
              }
            });
          } else {
            updetePillar({
              ...this.form,
              pillarId: this.updateId
            }).then(r => {
              if (r.data) {
                this.$message.success(r.msg || "修改成功！");
                this.dialogFormVisble = false;
                this.onGetDataList();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删
    deleteData(row) {
      this.$confirm(`提示，确定要删除该条数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          deletePillar({ ids: [row.pillarId] }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 改
    updateData(row) {
      this.dialogTitle = "修改";
      this.dialogFormVisble = true;
      this.updateId = row.pillarId;
      pillarById({ id: row.pillarId }).then(res => {
        Object.assign(this.form, res?.data);
      });
    },
    // 查
    onGetDataList() {
      this.tableLoading = true;
      getPillarList({
        ...this.queryParams,
        ...this.pageParams
      })
        .then(res => {
          const { records, total } = res.data;
          this.tableData = records.map(item => {
            return {
              ...item,
              type:
                item.type === 2 ? "桥隧" : item.type === 0 ? "站场" : "区间",
              lineType:
                item.lineType === 0
                  ? "单线"
                  : item.lineType === 1
                    ? "上行"
                    : "下行"
            };
          });
          this.pageParams.total = total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    handlepillarAdd() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    handleDialogClose() {
      this.resetForm("form");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
      this.pageParams.pageNum = 1
      this.pageParams.pageSize = 10
      this.queryParams.pillarNum = "";
      this.onSearch();
    },
    // 分页方法
    onChangePages(pageInfo) {
      this.pageParams.pageNum = pageInfo.page;
      this.pageParams.pageSize = pageInfo.limit;
      this.onGetDataList();
    }
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
  height: 95vh;
}

.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}

.custom-tree-node {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .tree-node-label {
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
